import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  get_jobs_hiring_manager_action,
  get_all_applied_mentor_list_action,
} from "../../../redux/_actions";

function useAllAppliedMentor() {
  const [loading, setLoading] = useState(false);
  const [appliedMentors, setAppliedMentors] = useState();
  const [assignedMentors, setAssignedMentors] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { jobsPostedData } = useSelector(
    (state) => state.get_jobs_hiring_manager_reducer
  );

  const {appliedMentorsData} = useSelector((state) => state.get_all_applied_mentor_reducer);

  useEffect(() => { 
      callApi();
  }, []);

  useEffect(() => {
    if (appliedMentorsData?.data) {
      let data = appliedMentorsData?.data && appliedMentorsData.data?.results;
      setAppliedMentors(data);
    }
  }, [appliedMentorsData]);

  useEffect(() => {
    if (jobsPostedData?.data) {
      let data = jobsPostedData?.data;
      let results = data.results.filter((item) => item.mentor_name !== null);
      setAssignedMentors(results);
    }
  }, [jobsPostedData]);


  const callApi = async (id) => {
    setLoading(true);
    await dispatch(get_jobs_hiring_manager_action());
    await dispatch(get_all_applied_mentor_list_action());
    setLoading(false);
  };


  const onViewMentorProfileClick = async (id, jobTitle) => {
    navigate(`/view-mentor-profile/${id}`, {
      state: {
        id: id,
        jobTitle: jobTitle,
      }
    });
  };

  const onBackClick = () => {
    navigate(-1);
  };

  const onViewJobsDetail = (id) => {
    navigate(`/hiring-manager-kanboard/${id}`, {
      state: id,
    });
  }

  return {
    loading,
    appliedMentors,
    assignedMentors,
    onViewMentorProfileClick,
    onBackClick,
    onViewJobsDetail
  };
}

export default useAllAppliedMentor;
